/*
 * @Author: zjw
 * @Date: 2021-06-03 17:12:35
 * @LastEditTime: 2021-07-16 16:42:29
 * @FilePath: \web-app\src\store\observable.js
 * @Environment: Vue + Element
 * @Description: 
 */
import Vue from 'vue'
export const store = Vue.observable({
    projectName: '威胁情报信息服务平台',
    userInfo: {
        name: 'zjw',
        age: 24
    }
})

// 定义 mutations, 修改属性
export const mutations = {
    setProjectName(item) {
        store.projectName = item.projectName
    },
    setUserInfo(userInfo) {
        store.userInfo = userInfo
    }
}